export default "__VITE_ASSET__9Eg_caF5__"